import {FormPost, GET, POST} from "../util";
import {isValueSet} from "@/common/format";

const registrationUrl = "api/registration/";

const url = {
    submitInitialRegistration: `${registrationUrl}submit`,
    settings: `${registrationUrl}settings`,
    checkInvitationCode: `${registrationUrl}invitation-code/check`,
    checkLegalData: `${registrationUrl}legal/check`,
    checkBankAccount: `${registrationUrl}bank-account/check`,
    uploadRegistrationDocument: `${registrationUrl}registration-document/upload`,
    resendMail: `${registrationUrl}resend-mail`,
    termsOfPartner: `api/platformdoc/terms-of-partner/{invitationCode}/`
};

const registrationApi = {
    submitInitialRegistration: function submit(params = {}) {
        return POST(url.submitInitialRegistration, params);
    },
    getSettings: (code) => {
        let codePart = isValueSet(code) ? "/" + code : "";
        return GET(url.settings + codePart);
    },
    checkInvitationCode: (code) => {
        return GET(url.checkInvitationCode + "/" + code);
    },
    checkLegalData: (data) => {
        return POST(url.checkLegalData, data);
    },
    checkBankAccount: (data) => {
        return POST(url.checkBankAccount, data);
    },
    uploadRegistrationDocument: (params) => {
        return FormPost(url.uploadRegistrationDocument, params);
    },
    resendMail: (email) => {
        return POST(url.resendMail, email, "application/json", 'String');
    },
    isTermsOfPartnerAvailable:(invitationCode) => {
        return GET(url.termsOfPartner.replace("{invitationCode}", invitationCode) + "exists")
    },
    buildTermsOfPartnerUrl(invitationCode) {
        return url.termsOfPartner.replace("{invitationCode}", invitationCode) + "download";
    }
};
export {
    registrationApi
};